export enum SearchSource {
  Google = 'google',
  Yandex = 'yandex',
}
